import { useState } from "react";
import { FORM_COMPACT_CONTROL_CLASS } from "../../../ui/styles/formStyles";
import { wordingsOf, wordingsText } from "./artifactTables";

/** Wordings as one text, separated by `;`; the cell keeps what is typed until it loses focus. */
export default function WordingsInput({ label, wordings, onChange, className }: { label: string; wordings: readonly string[]; onChange: (wordings: readonly string[]) => void; className?: string }) {
  const [typed, setTyped] = useState<string | null>(null);
  return (
    <input
      className={className ?? FORM_COMPACT_CONTROL_CLASS}
      aria-label={label}
      value={typed ?? wordingsText(wordings)}
      onChange={(event) => {
        setTyped(event.target.value);
        onChange(wordingsOf(event.target.value));
      }}
      onBlur={() => {
        setTyped(null);
      }}
    />
  );
}
